import { render, staticRenderFns } from "./DestroyingModal.vue?vue&type=template&id=d22da9dc&"
import script from "./DestroyingModal.vue?vue&type=script&lang=js&"
export * from "./DestroyingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports